import XLSX from 'xlsx-js-style';
import { Download16 } from '../../../images/icons/icons_theme';

/**
 * @충실도팝업엑셀다운로드
 * 월별전송내역 / 월별정보관리내역 팝업 전용 엑셀 다운로드.
 *   1) 컬럼별 내용 길이에 맞춘 너비 자동 계산
 *   2) NEDIS 표준 양식과 동일한 헤더 강조색(하늘색)
 *   3) 나이 등 표기가 어색한 값 보정
 *
    <FidelityPopupExcelDownload
        data={data}                     // 팝업 조회 결과
        searched={isSearched}
        menuName={'월별전송내역'}       // 호출한 메뉴
        ratioName={'재검토율'}          // 선택한 셀의 비율 종류
        sendData={sendData}            // 팝업 호출 시 넘긴 검색조건(항목명 / 기관 / 내원기간)
    />
 * **/

/**
 * [헤더명, 컬럼명, 공통항목여부] 공통항목여부는 해당 양식에서 헤더가 하늘색으로 칠해진 컬럼을 의미함
 * (화면 그리드는 기존대로 요약 컬럼만 표출하고, 엑셀만 전체 항목 내려받기)
 */
const COLUMNS = [
    ['병원명', 'EMOGDESC', true],
    ['환자등록번호', 'PTMIIDNO', true],
    ['내원일자', 'PTMIINDT', true],
    ['내원시간', 'PTMIINTM', true],
    ['성명', 'PTMINAME', true],
    ['생년월일-나이', 'PTMIBRTD', true],
    ['성별', 'PTMISEXX', true],
    ['보험유형', 'PTMIIUKD', true],
    ['요양기관번호', 'PTMIHSCD', true],
    ['진료의사 면허번호', 'PTMIDRLC', true],
    ['발병일자', 'PTMIAKDT', false],
    ['발병시간', 'PTMIAKTM', false],
    ['내원사유(질병여부)', 'PTMIDGKD', true],
    ['내원사유(의도성여부)', 'PTMIARCF', false],
    ['내원사유(손상기전)', 'PTMIARCS', false],
    ['내원경로', 'PTMIINRT', true],
    ['내원수단', 'PTMIINMN', true],
    ['주증상', 'PTMIMNSY', true],
    ['증상-2', 'PTMISYM2', true],
    ['증상-3', 'PTMISYM3', true],
    ['응급증상 해당유무', 'PTMIEMSY', true],
    ['환자 내원시 반응', 'PTMIRESP', false],
    ['내원시 수축기혈압', 'PTMIHIBP', false],
    ['내원시 이완기혈압', 'PTMILOBP', false],
    ['내원시 분당 맥박수', 'PTMIPULS', false],
    ['내원시 분당 호흡수', 'PTMIBRTH', false],
    ['내원시 체온', 'PTMIBDHT', false],
    ['내원시 산소포화도', 'PTMIVOXS', false],
    ['최초중증도 분류과정', 'PTMIKPR1', true],
    ['최초 중증도분류 결과', 'PTMIKTS1', true],
    ['최초 중증도분류 일시', 'PTMIKTDT', true],
    ['최초 중증도분류 시간', 'PTMIKTTM', true],
    ['최초 중증도분류자 직종', 'PTMIKJOB', true],
    ['최초 중증도분류자 면허 또는 자격번호', 'PTMIKIDN', true],
    ['최종진료구역', 'PTMIAREA', false],
    ['주된진료를 받은 응급의료센터', 'PTMIMDCD', false],
    ['전문의 진료여부', 'PTMISDCD', false],
    ['응급진료 결과', 'PTMIEMRT', true],
    ['입원경로', 'PTMIHSRT', false],
    ['주진료과', 'PTMIDEPT', false],
    ['응급실 퇴실일자', 'PTMIOTDT', true],
    ['응급실 퇴실시간', 'PTMIOTTM', true],
    ['입원후 결과', 'PTMIDCRT', true],
    ['퇴원일자', 'PTMIDCDT', true],
    ['퇴원시간', 'PTMIDCTM', true],
    ['기타증상', 'PTMIETSY', true],
    ['교통사고당사자', 'PTMITAIP', false],
    ['교통사고보호장구-안전밸트', 'PTMITSBT', false],
    ['교통사고보호장구-아동용좌석', 'PTMITSCS', false],
    ['교통사고보호장구-전면에어백', 'PTMITSFA', false],
    ['교통사고보호장구-측면에어백', 'PTMITSSA', false],
    ['교통사고보호장구-헬멧', 'PTMITSHM', false],
    ['교통사고보호장구-보호대', 'PTMITSPT', false],
    ['교통사고보호장구-착용안함', 'PTMITSNO', false],
    ['교통사고보호장구-비해당', 'PTMITSUR', false],
    ['교통사고보호장구-미상', 'PTMITSUK', false],
    ['응급진료결과 기타 TEXT', 'PTMIETTX', true],
    ['내원기준 전송일시', 'PTMITIDT', true],
    ['내원기준 전송시간', 'PTMITITM', true],
    ['퇴실기준 전송일시', 'PTMITODT', true],
    ['퇴실기준 전송시간', 'PTMITOTM', true],
    ['퇴원기준 전송일시', 'PTMITDDT', true],
    ['퇴원기준 전송시간', 'PTMITDTM', true],
    ['재난고유번호 (NEDIS6차 추가)', 'PTMIDSID', false],
    ['구급일지고유번호 (NEDIS6차 추가)', 'PTMIREID', false],
    ['전원 보낸 의료기관종류 (NEDIS6차 추가)', 'PTMIINTP', false],
    ['전원 보낼 의료기관종류 (NEDIS6차 추가)', 'PTMIDCTP', false],
    ['환자의 주소지', 'PTMIZIPC', true],
    ['전원보낸의료기관코드', 'PTMIINCD', false],
    ['전원보낼의료기관코드', 'PTMIDCCD', false],
    ['입원날짜', 'PTMIHSDT', true],
    ['입원시간', 'PTMIHSTM', true]
];

// 헤더 배경색
const HIGHLIGHT_FILL = 'D4E9FF';
const DEFAULT_FILL = 'F2F4F7';

// 컬럼 너비 (한글 2칸 기준)
const MIN_WIDTH = 9;
const MAX_WIDTH = 28;
const WIDTH_PADDING = 2;

/**
 * 나이(PTMIBRTD)는 '076.00' 형태로 저장되어 있어 앞자리 0 과 무의미한 소수점 정리
 * 단 '000.07'(0세 7개월) 처럼 소수부가 의미를 갖는 경우가 있어 값 자체는 보존 (076.00 -> 76 / 000.07 -> 0.07)
 */
const formatCell = (code, value) => {
    if (value === null || value === undefined) return '';

    if (code === 'PTMIBRTD') {
        const str = String(value).trim();
        return /^\d+(\.\d+)?$/.test(str) ? String(Number(str)) : str;
    }

    return value;
};

// 한글을 2칸으로 계산한 표시 폭
const displayWidth = (value) => {
    const str = String(value ?? '');
    let width = 0;
    for (let i = 0; i < str.length; i++) {
        width += str.charCodeAt(i) > 0x7f ? 2 : 1;
    }
    return width;
};

// 파일명에 쓸 수 없는 문자 정리 (Windows 기준 \ / : * ? " < > |)
const sanitizeFileName = (value) => String(value ?? '')
    .replace(/[\\/:*?"<>|]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const FidelityPopupExcelDownload = ({ data, searched, menuName, ratioName, sendData }) => {

    /**
     * 파일명 : 메뉴_기관명_내원기간_항목_비율
     * ex) 월별전송내역_○○대학교병원_202601_발병일시_재검토데이터목록.xlsx
     */
    const buildFileName = (rows) => {
        const emogdesc = rows.find(row => row?.EMOGDESC)?.EMOGDESC ?? '';
        const yyyymm = sendData?.fromindt ? String(sendData.fromindt).substring(0, 6) : '';

        return [menuName, emogdesc, yyyymm, sendData?.clsdesc, ratioName]
            .map(sanitizeFileName)
            .filter(Boolean)
            .join('_');
    };

    const excelDownload = () => {
        const rows = Array.isArray(data) ? data : [];

        const head = COLUMNS.map(([title]) => title);
        const body = rows.map(row => COLUMNS.map(([, code]) => formatCell(code, row[code])));

        const worksheet = XLSX.utils.aoa_to_sheet([head, ...body]);

        // 컬럼별 내용 길이에 맞춰 너비 산정 (헤더는 두 줄까지 접히므로 절반만 반영)
        worksheet['!cols'] = COLUMNS.map(([title], colIdx) => {
            const bodyWidth = body.reduce(
                (max, row) => Math.max(max, displayWidth(row[colIdx])), 0
            );
            const headWidth = Math.ceil(displayWidth(title) / 2);
            const width = Math.max(headWidth, bodyWidth) + WIDTH_PADDING;

            return { wch: Math.min(MAX_WIDTH, Math.max(MIN_WIDTH, width)) };
        });

        // 헤더는 줄바꿈 표출되므로 행 높이 확보
        worksheet['!rows'] = [{ hpt: 34 }];

        const border = {
            top: { style: 'thin', color: { rgb: 'D9D9D9' } },
            bottom: { style: 'thin', color: { rgb: 'D9D9D9' } },
            left: { style: 'thin', color: { rgb: 'D9D9D9' } },
            right: { style: 'thin', color: { rgb: 'D9D9D9' } }
        };

        const range = XLSX.utils.decode_range(worksheet['!ref']);

        for (let r = range.s.r; r <= range.e.r; r++) {
            for (let c = range.s.c; c <= range.e.c; c++) {
                const address = XLSX.utils.encode_cell({ r, c });
                if (!worksheet[address]) worksheet[address] = { t: 's', v: '' };

                const isHead = r === 0;
                const highlighted = COLUMNS[c]?.[2];

                worksheet[address].s = {
                    font: { name: '맑은 고딕', sz: 10, bold: isHead },
                    border: border,
                    alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
                    ...(isHead && {
                        fill: {
                            patternType: 'solid',
                            fgColor: { rgb: highlighted ? HIGHLIGHT_FILL : DEFAULT_FILL }
                        }
                    })
                };
            }
        }

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, '통합 문서1');
        XLSX.writeFile(workbook, `${buildFileName(rows)}.xlsx`);
    };

    return (
        <button
            disabled={!(searched && data?.length)}
            onClick={excelDownload}
            className='excel_btn'
        >
            <Download16 className='co_white' />
            엑셀다운로드
        </button>
    );
};

export default FidelityPopupExcelDownload;
